const s = {
  name: "StackOfCreditCards",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17,21H5v-2h12V21z"/>
		<path class="st0" d="M0,5c0-2.8,2.2-5,5-5h30c2.8,0,5,2.2,5,5v16c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5z M5,2C3.3,2,2,3.3,2,5h36
			c0-1.7-1.3-3-3-3H5z M2,10h36V7H2V10z M2,12v9c0,1.7,1.3,3,3,3h30c1.7,0,3-1.3,3-3v-9H2z"/>
		<path class="st0" d="M0,30h40v-2H0V30z"/>
		<path class="st0" d="M40,34H0v-2h40V34z"/>
		<path class="st0" d="M0,38h40v-2H0V38z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as StackOfCreditCards
};
